const env = {
  API_URL: process.env.REACT_APP_API_URL,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  GHL: {
    CLIENT_ID: process.env.REACT_APP_GHL_CLIENT_ID,
    SCOPE:
      'calendars.write calendars/events.readonly calendars/events.write calendars/groups.readonly calendars/groups.write calendars/resources.readonly calendars/resources.write campaigns.readonly conversations.readonly conversations.write conversations/message.readonly conversations/message.write conversations/reports.readonly conversations/livechat.write contacts.readonly contacts.write objects/schema.readonly objects/schema.write objects/record.readonly objects/record.write associations.write associations.readonly associations/relation.readonly associations/relation.write locations.readonly locations/customValues.readonly locations/customValues.write locations/customFields.readonly locations/customFields.write locations/tags.readonly locations/tags.write medias.readonly medias.write socialplanner/oauth.readonly socialplanner/oauth.write socialplanner/post.readonly socialplanner/post.write socialplanner/account.readonly socialplanner/account.write users.readonly workflows.readonly opportunities.write opportunities.readonly',

    REDIRECT: {
      ASSOCIATE: process.env.REACT_APP_GHL_REDIRECT_ASSOCIATE,
    },
  },
}

export default env


